module.exports = __webpack_public_path__ + "static/img/warehouse03.60bc546.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warehouse03.jpg
// module id = UaVf
// module chunks = 0